import React from 'react';

const Logo = (props) => {
  return (
    <img
      alt="Logo"
      src="/static/mathlife_cloud_1.png"
      {...props}
    />
  );
};

export default Logo;
